'use client'
import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { MediaBox } from 'components/MediaBox'
import { Typography } from 'components/Contentful'
import styles from './ByTheNumbers.module.scss'
import { BLOCKS } from '@contentful/rich-text-types'
import { AchieveTheme, Grid } from '@achieve/ascend'

const ByTheNumbers = ({ content }) => {
  const {
    heading,
    mainDisclaimer,
    subtitle,
    titleOne,
    subTitleOne,
    imageOne,
    disclaimerOne,
    titleTwo,
    subTitleTwo,
    imageTwo,
    disclaimerTwo,
    titleThree,
    subTitleThree,
    imageThree,
    disclaimerThree,
  } = useMemoizedContentGetter(content, [
    'heading',
    'mainDisclaimer',
    'subtitle',
    'titleOne',
    'subTitleOne',
    'imageOne',
    'disclaimerOne',
    'titleTwo',
    'subTitleTwo',
    'imageTwo',
    'disclaimerTwo',
    'titleThree',
    'subTitleThree',
    'imageThree',
    'disclaimerThree',
  ])
  return (
    <Section
      backgroundColor={AchieveTheme?.ascend?.colors?.neutral?.[0]}
      data-testid="home-by-the-numbers-section"
      contain={false}
      className={styles['home-by-the-numbers-container']}
    >
      <MediaBox
        title={heading}
        subtitle={subtitle}
        titles={[titleOne?.textContent, titleTwo?.textContent, titleThree?.textContent]}
        subtitles={[subTitleOne?.textContent, subTitleTwo?.textContent, subTitleThree?.textContent]}
        disclaimers={[
          disclaimerOne?.textContent,
          disclaimerTwo?.textContent,
          disclaimerThree?.textContent,
        ]}
        images={[imageOne?.mediaContent, imageTwo?.mediaContent, imageThree?.mediaContent]}
        alts={[imageOne?.mediaAltText, imageTwo?.mediaAltText, imageThree?.mediaAltText]}
      />
      {mainDisclaimer && (
        <Grid container justifyContent="center">
          <Typography
            content={mainDisclaimer?.textContent}
            variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyXs' }}
            className={styles['disclaimer']}
          />
        </Grid>
      )}
    </Section>
  )
}
export { ByTheNumbers }
export default ByTheNumbers
